export function getComponentValues(c1IdealValue, stageFp, stageQ, gain) {
  let capacitorRatio = computeCapacitorRatio(stageQ, gain);
  let c2IdealValue = c1IdealValue * capacitorRatio;
  let r2IdealValue = computeR2IdealValue(c1IdealValue, c2IdealValue, stageFp);
  let r1IdealValue = r2IdealValue;

  return {
    c1IdealValue: c1IdealValue,
    c2IdealValue: c2IdealValue,
    r1IdealValue: r1IdealValue,
    r2IdealValue: r2IdealValue,
  };
}

function computeCapacitorRatio(stageQ, gain) {
  var a = 4;
  var b = 4 * (1 - gain) - 1 / (stageQ * stageQ);
  var d = (1 - gain) * (1 - gain);
  var result = (-b + Math.sqrt(b * b - 4 * a * d)) / (2 * a);
  return result;
}

function computeR2IdealValue(c1IdealValue, c2IdealValue, stageFp) {
  return 1 / (2 * Math.PI * stageFp * Math.sqrt(c1IdealValue * c2IdealValue));
}
